import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import i18next from "i18next";
import {default as PopupWrapperInternal} from "@mnjsplatform/components/lib/common/PopupWrapper";
import {CommandContext} from "@mnjsplatform/data";
import Instruction from "./Instruction";
import reactToText from "react-to-text";

class PopupWrapper extends React.Component {
    static contextType = CommandContext;

    constructor(props) {
        super(props);
        this.state = {
            settings: null
        }
    }

    componentDidMount() {
        this.initialize()
    }

    initialize = async () => {
        /*Ключ:
            WorkSiteId – идентификатор РМ
            CommandItemId – идентификатор команды в РМ
            PlaceholderId – идентификатор фрейма в команде
            PlaceholderName – наименование фрейма*/
        const menuItem = this.props.menuId ? this.props.menuItems.find(mi => mi.MenuID === this.props.menuId)
            : this.props.menuItems.find(mi => mi.AppCommand && mi.AppCommand.Param1 === this.context.key);
        this.command = menuItem?.AppCommand;
        this.placeholderId = this.props.instructionId || "POPUP_WRAPPER";
        const cleanTitle = reactToText(this.props.title);
        let title = this.props.staticTitle || cleanTitle || this.props.title;
        if (this.props.getTitle) {
            title = this.props.getTitle();
        }

        this.key = {
            WorkSiteId: this.context.workplaceId,
            CommandItemId: this.command.ID,
            PlaceholderId: this.placeholderId,
            PlaceholderName: title
        };
        await this.props.dispatch(this.props.dataItemInfo.reset());
        await this.props.dispatch(this.props.dataItemInfo.execute(this.key));
        this.setState({settings: this.props.dataItemInfo.getRow(0)})
    }

    render() {
        if (!this.state.settings) {
            return null;
        }
        if (this.state.settings["IsPlaceholderVisible"] != null && this.state.settings["IsPlaceholderVisible"] !== 1) {
            return null;
        }
        const customTitle = this.state.settings["PlaceholderNameUser"] || this.props.title;
        return (<PopupWrapperInternal {...this.props} title={customTitle}>
                {this.props.showInstruction && this.command &&
                    <Instruction instructionId={this.props.instructionId} {...this.state.settings}/>}
                {this.props.children}
            </PopupWrapperInternal>
        );
    }
}

PopupWrapper.propTypes = {
    popupVisible: PropTypes.bool.isRequired,
    title: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.object.isRequired]).isRequired,
    onClose: PropTypes.func.isRequired,
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    confirmText: PropTypes.string,
    renderButtons: PropTypes.func,
    minHeightBody: PropTypes.string,
    maxWidthBody: PropTypes.string,
    bodyMaxHeightCalculateFunc: PropTypes.func,
    style: PropTypes.object,
    headerStyle: PropTypes.object,
    closeControl: PropTypes.object,
    bodyStyle: PropTypes.object,
    usePortal: PropTypes.bool,
    showInstruction: PropTypes.bool,
    staticTitle: PropTypes.string,
    instructionId: PropTypes.string,
    getTitle: PropTypes.func,
    menuId: PropTypes.string,
    menuItems: PropTypes.array,
    dispatch: PropTypes.func.isRequired
};

PopupWrapper.defaultProps = {
    confirmText: i18next.t("Close"),
    maxWidthBody: "1000px",
    headerStyle: {},
    bodyStyle: {},
    closeControl: <button type="button" className="close" data-dismiss="modal"><>&times;</>
    </button>,
    usePortal: true,
    showInstruction: true
}

function mapStateToProps(state) {
    return {
        menuItems: state.appState.appParams.menu.Items,
        dataItemInfo: state.instructionState.PersOffHelp_GetHelpForPO
    };
}

export default connect(mapStateToProps)(PopupWrapper);